/** Sections the email preference pages group topics under, in display order. */
export const groupIds = [
	'chat',
	'assignments',
	'job-updates',
	'plan-comparison',
	'recipe-admin',
] as const;

export const groupLabels = {
	chat: 'Chat',
	assignments: 'Assignments',
	'job-updates': 'Job & design updates',
	'plan-comparison': 'Plan comparison',
	'recipe-admin': 'Recipe admin',
} as const satisfies Record<(typeof groupIds)[number], string>;
